import styled from "styled-components";

export const PaginationContainer = styled.nav`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const PaginationList = styled.ul`
  display: flex;
  padding-left: 0;
  list-style: none;
`;

export const PaginationItem = styled.li`
  display: inline-block;
`;

export const PaginationLink = styled.button`
  color: ${(props) => props.theme.theme.TEXT.PRIMARY};
  background-color: ${(props) => props.theme.theme.BACKGROUND.SURFACE} !important;
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.theme.COLOR_ACCENT};
  }
  &:focus {
    outline: none;
  }
`;
